// extracted by mini-css-extract-plugin
export default {"itemsList":"BOMItemsList__itemsList--E5qQQ","group":"BOMItemsList__group--KKmmr","title":"BOMItemsList__title--rFuDD"};